import React, { useEffect, useState } from "react";
import FootageCreateNTF from "./footage/leasing.f.createntf";
import { Auth, Storage } from "aws-amplify";
import FootageTableMain from "./footage/leasing.f.tablemain";
import { useParams } from "react-router-dom";
import FootageCreateTF from "./footage/leasing.f.createtf";
import { getCurrentLocalDateTime } from "../../utils/getLocalDateTime";
import CelesFloatingInputState from "./components/leasing.c.celesfloatinginputstate";
import API from "./api/api.main";

const today = getCurrentLocalDateTime();
function LeasingSandboxMain() {
  const [loading, setLoading] = useState(true);
  const [leasings, setLeasings] = useState([]);
  const [error, setError] = useState(null);
  const [date, setDate] = useState("2022-01-01");
  const [isChange, setIsChange] = useState(false);
  const params = useParams();

  useEffect(() => {
    fetchLoanLeasing();
  }, [params, isChange]);

  const fetchLoanLeasing = async () => {
    try {
      setLoading(true);
      const requestData = await API.get(
        "MoneyHubAdmin",
        `/leasing/loanSandbox?category=${String(params.category).toUpperCase()}`
      );
      if (requestData?.leasings) {
        setLeasings(requestData.leasings);
      }
    } catch (error) {
      console.log("fetch loan leasing", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-100 p-10 pt-20">
      {params?.category === "ntf" ? (
        <FootageCreateNTF
          setIsChange={setIsChange}
          setDate={setDate}
          fetchLoanLeasing={fetchLoanLeasing}
        />
      ) : (
        <FootageCreateTF
          setIsChange={setIsChange}
          setDate={setDate}
          fetchLoanLeasing={fetchLoanLeasing}
        />
      )}

      <div className="bg-white mt-4 p-4">
        <div className="bg-white rounded  border-blue-400 w-full overflow-x-auto ">
          <FootageTableMain
            isChange={isChange}
            date={date}
            category={String(params.category).toUpperCase()}
            refetch={fetchLoanLeasing}
            loading={loading}
            leasings={leasings}
            env="sandbox"
          />
        </div>
      </div>
    </div>
  );
}

export default LeasingSandboxMain;
